export default function PartyDareSupport() {
  const faqs = [
    {
      q: "How do I play?",
      a: "Pick one of the five games on the home screen, add at least two player names, choose a spice level, and pass the phone around. Each card tells the current player exactly what to do. Anyone can skip a card they don't like.",
    },
    {
      q: "What are the five games?",
      a: "Truth or Dare (answer honestly or take the dare), Never Have I Ever (find out what your friends have really done), Would You Rather (impossible choices), Most Likely To (point at the friend who fits), and Paranoia (whisper the question, answer out loud).",
    },
    {
      q: "What do the spice levels mean?",
      a: "Casual is light and funny — safe for everyone 13+, including family. Party is bolder and more embarrassing, made for good friends. Spicy is flirty and intended for adult groups and couples (17+). There is no explicit content at any level, and no level references alcohol.",
    },
    {
      q: "How do I unlock the Spicy level?",
      a: "Watch one short rewarded ad to unlock Spicy for your current session, or upgrade to Pro once to keep it permanently unlocked along with removing all ads.",
    },
    {
      q: "Does the app work offline?",
      a: "Yes. Every question and dare is bundled inside the app. Airplane mode, a basement, a beach, a road trip — the games always work. Only ads and the cross-promotion banner need a connection.",
    },
    {
      q: "Which languages are supported?",
      a: "The interface is available in 15 languages. The game decks themselves are fully written — not machine-translated — in English, Spanish, Portuguese, German, French, Hindi, Indonesian, and Turkish. Other languages currently fall back to English decks.",
    },
    {
      q: "How does the Pro upgrade work?",
      a: "Pro is a one-time purchase, not a subscription. It removes all advertising and keeps the Spicy level permanently unlocked. Use 'Restore purchases' in Settings if you reinstall the app or switch phones with the same Google account.",
    },
    {
      q: "Are the player names shared anywhere?",
      a: "No. Player names live only on your phone so your last group can be restored. Nothing you type or play is uploaded.",
    },
    {
      q: "The app is crashing — what should I do?",
      a: "First make sure you have the latest version from Google Play. Then try clearing the app's cache (Android Settings → Apps → PartyDare → Storage → Clear cache). If it keeps happening, email us with your device model and Android version — crash reports help us fix issues quickly.",
    },
    {
      q: "Can I suggest new questions or games?",
      a: "Absolutely — we love deck ideas. Email your suggestions and the language they're written for, and the funniest ones may ship in a future update.",
    },
  ];

  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-10 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            PartyDare Support
          </h1>
          <p className="mt-3 text-[#5B6B7C]">
            5 party games. One phone. Zero boredom. — We&apos;re here to
            help you keep the party going.
          </p>
          <p className="mt-2 text-xs text-[#8A93A2]">
            An app by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="mb-10 rounded-xl border border-[#E1DCCE] bg-white p-6 text-center">
          <h2 className="text-xl font-bold text-[#A8720E]">Contact us</h2>
          <p className="mt-2 text-[#5B6B7C]">
            Questions, bug reports, or deck suggestions — email{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>{" "}
            and we&apos;ll get back to you, usually within 48 hours.
          </p>
        </div>

        <h2 className="mb-6 text-2xl font-bold text-[#A8720E]">
          Frequently Asked Questions
        </h2>
        <div className="space-y-6">
          {faqs.map((f) => (
            <div
              key={f.q}
              className="rounded-lg border border-[#E1DCCE] bg-white p-5"
            >
              <h3 className="font-semibold text-[#26313B]">{f.q}</h3>
              <p className="mt-2 leading-relaxed text-[#5B6B7C]">{f.a}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center text-sm text-[#5B6B7C]">
          <p>
            Read the{" "}
            <a
              href="/apps/partydare/privacy-policy"
              className="text-[#0F6BBF] underline"
            >
              PartyDare Privacy Policy
            </a>
            .
          </p>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          &copy; 2026 Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
